import { http, HttpResponse } from 'msw';

const handlers = [
  http.get('/api/credentials', () => {
    return HttpResponse.json({
      items: [
        {
          cloud: 'gcp',
          credentials: '',
          freeTrial: false,
          id: '78f7b687-2f95-4087-9da2-ad467559dd77',
          name: 'adko-gcp',
          usedBy: [],
        },
      ],
    });
  }),
  http.get('/api/credentials/:credentialsId', () => {
    return HttpResponse.json({});
  }),
];

export default handlers;
